/**
 * auth pages that must never be used as the post-login destination.
 */
const AUTH_PATHS = ['/', '/login', '/logout', '/entra-authenticator'];

/**
 * unwraps nested redirectTo params and drops auth pages, returning the page the user actually wanted.
 * @returns {string | null} the target url, or null when there is none.
 */
export function resolveRedirectTarget(
  url: string | null | undefined
): string | null {
  if (!url) {
    return null;
  }

  const [path, query = ''] = url.split('?');
  if (!AUTH_PATHS.includes(path)) {
    return url;
  }

  return resolveRedirectTarget(new URLSearchParams(query).get('redirectTo'));
}
